<div class="st-add-team-member-label">
    {{languageSettings.PSTWebAddNewTeamMemberLabel}}
</div>
<mat-divider class="st-add-team-member-divider"></mat-divider>
<div class="st-add-team-member-container">
    <text-field [placeholder]="languageSettings.PSTWebUserHeaderIDLabel"
                [value]="newUser.UserID"
                [required]="disabled"
                [label]="languageSettings.PSTWebUserHeaderIDLabel"
                (changed)="onNewUserChanged($event, 'UserID')">
    </text-field>
    <text-field class="st-add-team-member-container-item"
                [placeholder]="languageSettings.PSTWebUserHeaderFirstNameLabel"
                [value]="newUser.GivenName"
                [required]="disabled"
                [label]="languageSettings.PSTWebUserHeaderFirstNameLabel"
                (changed)="onNewUserChanged($event, 'GivenName')">
    </text-field>
    <text-field [placeholder]="languageSettings.PSTWebUserHeaderLastNameLabel"
                [value]="newUser.Surname"
                [required]="disabled"
                [label]="languageSettings.PSTWebUserHeaderLastNameLabel"
                (changed)="onNewUserChanged($event, 'Surname')">
    </text-field>
    <text-field [placeholder]="languageSettings.PSTWebUserHeaderEmailLabel"
                [value]="newUser.Email"
                [label]="languageSettings.PSTWebUserHeaderEmailLabel"
                (changed)="onNewUserChanged($event, 'Email')">
    </text-field>
    <text-field [placeholder]="languageSettings.PSTWebUserHeaderSSOEmailLabel"
                [value]="newUser.SSOLogins"
                [label]="languageSettings.PSTWebUserHeaderSSOEmailLabel"
                (changed)="onNewUserChanged($event, 'SSOLogins')">
    </text-field>
    <mat-form-field>
        <mat-label>{{languageSettings.PSTWebUserHeaderDefaultTeamLabel}}</mat-label>
        <mat-select [(ngModel)]="newUser.Program"
                    [required]="disabled"
                    [formControl]="internalProgramFormControl"
                    [placeholder]="languageSettings.PSTWebUserHeaderDefaultTeamLabel">
            <mat-option *ngFor="let group of globalTablesService?.GroupsArray"
                        [value]="group.ID">
                {{group.Description}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{languageSettings.PSTWebUserHeaderRoleLabel}}</mat-label>
        <mat-select [(ngModel)]="newUserCurrentRole"
                    [required]="disabled"
                    [formControl]="internalRoleFormControl"
                    (selectionChange)="newUserSelectRole()"
                    [placeholder]="languageSettings.PSTWebUserHeaderRoleLabel">
            <mat-option *ngFor="let role of inputData.data"
                        [value]="role">
                {{role.Description}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{languageSettings.PSTWebUserGroupSortByStatusLabel}}</mat-label>
        <mat-select [(ngModel)]="newUser.Active"
                    [required]="disabled"
                    [formControl]="internalStatusFormControl"
                    [placeholder]="languageSettings.PSTWebUserGroupSortByStatusLabel">
            <mat-option *ngFor="let item of InvitationStatusCodes.ACTIVE_STATUS_VALUES"
                        [value]="item.value">
                {{item.label}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<mat-divider class="st-add-team-member-divider"></mat-divider>

<mat-button-toggle-group class="st-add-team-member-button-group">
    <!-- <div class="st-add-team-member-button-cancel"
         (click)="cancelNew()">{{languageSettings.PSTWebCancelButtonLabel}}</div>
    <mat-button-toggle class="st-add-team-member-button-confirm"
                       (click)="addUser()">
        <ng-template [ngIf]="!loading"
                     [ngIfElse]="loader">
            {{languageSettings.PSTWebSaveMemberLabel}}
        </ng-template>
        <ng-template #loader>
            <loader [diameter]="30"
                    class="st-add-team-member-button-confirm--spinner"
                    [strokeWidth]="5"></loader>
        </ng-template>
    </mat-button-toggle> -->
    <button mat-button
            class="st-add-team-member-button-cancel"
            (click)="cancelNew()">
        {{languageSettings.PSTWebCancelButtonLabel}}
    </button>
    <button mat-button
            [disabled]="loading"
            class="st-add-team-member-button-confirm"
            (click)="addUser()">
        <ng-template [ngIf]="!loading"
                     [ngIfElse]="loader">
            {{languageSettings.PSTWebSaveMemberLabel}}
        </ng-template>
        <ng-template #loader>
            <loader [diameter]="30"
                    class="st-add-team-member-button-confirm--spinner"
                    [strokeWidth]="5"></loader>
        </ng-template>
    </button>
</mat-button-toggle-group>